import React from 'react';
import { ShareNetwork, Copy, Check } from '@phosphor-icons/react';
import { toast } from 'sonner';

export default function ShareButton({ type, id, title, className = '' }) {
  const handleShare = async () => {
    const API_URL = process.env.REACT_APP_BACKEND_URL;
    try {
      const res = await fetch(`${API_URL}/api/share/${type}/${id}`, { credentials: 'include' });
      const data = await res.json();

      if (navigator.share) {
        await navigator.share({ title: data.title, text: data.description, url: data.url });
      } else {
        await navigator.clipboard.writeText(data.url);
        toast.success('Link copied to clipboard!');
      }
    } catch (err) {
      if (err.name !== 'AbortError') toast.error('Share failed');
    }
  };

  return (
    <button onClick={handleShare} className={`flex items-center gap-1 text-[#9D4CDD] text-xs hover:text-[#B76FE8] transition-colors ${className}`} data-testid={`share-${type}-${id}`}>
      <ShareNetwork size={16} weight="bold" />
      <span>{title || 'Share'}</span>
    </button>
  );
}
